/* eslint-env browser, jquery */

function initFaqs() {
    'use strict';

    if (!jQuery.ui || !jQuery.ui.accordion) {
        return;
    }

    jQuery('.faq-accordion:not(.initFaqs)')
        .addClass('initFaqs')
        .accordion({
            heightStyle: 'content',
            collapsible: true,
            active: false,
            icons: false,
            activate: function(event, ui) {
                var scrollTop = jQuery('.faq-accordion').scrollTop();
                var top = jQuery(ui.newHeader).offset().top;
                jQuery('.faq-accordion').scrollTop(scrollTop + top - 200);
            },
            beforeActivate: function(event, ui) {
                var currHeader;
                var currContent;

                // The accordion believes a panel is being opened
                if (ui.newHeader[0]) {
                    currHeader = ui.newHeader;
                    currContent = currHeader.next('.ui-accordion-content');
                    // The accordion believes a panel is being closed
                } else {
                    currHeader = ui.oldHeader;
                    currContent = currHeader.next('.ui-accordion-content');
                }

                // Since we've changed the default behavior, this detects the actual status
                var isPanelSelected =
                    currHeader.prop('aria-selected') === 'true';

                // Toggle the panel's header
                currHeader
                    .toggleClass('ui-corner-all', isPanelSelected)
                    .toggleClass(
                        'accordion-header-active ui-state-active ui-corner-top',
                        !isPanelSelected
                    )
                    .prop('aria-selected', (!isPanelSelected).toString());

                // Toggle the panel's icon
                currHeader
                    .children('.ui-icon')
                    .toggleClass('ui-icon-triangle-1-e', isPanelSelected)
                    .toggleClass('ui-icon-triangle-1-s', !isPanelSelected);

                // Toggle the panel's content
                currContent.toggleClass(
                    'accordion-content-active',
                    !isPanelSelected
                );
                if (isPanelSelected) {
                    currContent.slideUp();
                } else {
                    currContent.slideDown();
                }

                return false; // Cancel the default action
            },
        });
}

(function($) {
    'use strict';

    // Create an accordion style layout for the FAQ.
    // =====================================================================
    $(function() {
        initFaqs();
    });
})(jQuery);
